var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHospital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 177,
    viewBox: "0 0 250 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1661 114.516C-14.8112 130.261 13.4457 153.85 18.6588 156.073C27.519 159.852 23.2108 166.567 41.3526 172.97C59.4945 179.373 83.1499 167.189 116.944 171.636C127.093 172.971 135.314 183.197 162.743 170.302C179.406 162.468 165.838 158.795 209.414 164.077C224.088 165.855 232.536 166.3 240.854 150.882C257.703 136.692 248.445 97.3293 233.583 89.2358C217.299 80.3675 243.157 49.6967 218.072 39.7417C201.692 33.2418 179.494 40.503 168.65 26.5097C159.149 14.2482 144.961 0 122.012 0C114.189 0 105.351 1.65473 95.3314 5.6078C64.9316 17.6013 81.4432 40.7231 31.6972 47.6847C6.11751 51.2643 11.0604 81.891 13.4456 88.2197C15.523 93.7325 29.2666 102.475 10.1661 114.516Z",
    fill: "#F3F9FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.339 21.8625H91.1599C91.1428 21.6887 91.1338 21.5128 91.1338 21.3347C91.1338 18.3309 93.5542 15.8957 96.5394 15.8957C97.4933 15.8957 98.3887 16.1453 99.1669 16.5818C100.266 13.5369 103.167 11.3618 106.573 11.3618C109.436 11.3618 111.941 12.8985 113.321 15.1965C113.922 15.0083 114.56 14.9068 115.222 14.9068C117.784 14.9068 119.994 16.4247 121.012 18.6153C121.362 18.5236 121.73 18.4746 122.108 18.4746C124.171 18.4746 125.897 19.9222 126.339 21.8625Z",
    fill: "#E2E6E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.071 49.3575H177.337C177.56 48.3793 178.43 47.6497 179.47 47.6497C179.661 47.6497 179.846 47.6743 180.023 47.7205C180.536 46.6162 181.65 45.851 182.942 45.851C183.275 45.851 183.597 45.9022 183.9 45.9971C184.595 44.8385 185.858 44.064 187.301 44.064C189.018 44.064 190.481 45.1604 191.035 46.6954C191.427 46.4754 191.879 46.3496 192.36 46.3496C193.864 46.3496 195.085 47.5772 195.085 49.0915C195.085 49.1812 195.08 49.2698 195.071 49.3575Z",
    fill: "#E2E6E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.767 38.3799H129.873C129.861 38.2619 129.854 38.1425 129.854 38.0215C129.854 35.9812 131.498 34.3271 133.526 34.3271C134.175 34.3271 134.783 34.4967 135.311 34.7931C136.058 32.7249 138.028 31.2476 140.341 31.2476C142.286 31.2476 143.988 32.2913 144.925 33.8523C145.333 33.7243 145.767 33.6554 146.216 33.6554C147.957 33.6554 149.457 34.6865 150.149 36.1745C150.387 36.1121 150.636 36.0788 150.893 36.0788C152.295 36.0788 153.467 37.0621 153.767 38.3799Z",
    fill: "#E2E6E9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.9585 46.4646H70.8721C71.0747 45.5775 71.8637 44.9155 72.8072 44.9155C72.9802 44.9155 73.1477 44.938 73.3081 44.9798C73.7738 43.9781 74.7835 43.284 75.9554 43.284C76.2581 43.284 76.5509 43.3305 76.8256 43.4165C77.4561 42.3657 78.6019 41.6631 79.9108 41.6631C81.4682 41.6631 82.7942 42.6575 83.2968 44.05C83.6526 43.8504 84.0625 43.7362 84.4984 43.7362C85.864 43.7362 86.9702 44.8498 86.9702 46.2234C86.9702 46.3047 86.9666 46.3852 86.9585 46.4646Z",
    fill: "#E2E6E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.8 150.117H235.551V136.953H234.8V150.117Z",
    fill: "#525B6C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.373 113.484L231.671 140.054H239.074L235.373 113.484Z",
    fill: "#C6D2CF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.906 138.369L238.549 136.274L238.448 135.554L232.015 137.581L231.906 138.369Z",
    fill: "#B3C1BE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.075 129.974L237.477 128.586L237.376 127.866L233.185 129.187L233.075 129.974Z",
    fill: "#B3C1BE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7432 143.379H31.386V135.835H30.7432V143.379Z",
    fill: "#525B6C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1773 122.384L29.0557 137.612H33.2989L31.1773 122.384Z",
    fill: "#C6D2CF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1904 136.646L32.9972 135.446L32.9397 135.032L29.2532 136.195L29.1904 136.646Z",
    fill: "#B3C1BE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8613 131.834L32.384 131.04L32.3264 130.626L29.9241 131.384L29.8613 131.834Z",
    fill: "#B3C1BE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5801 146.781H24.5491V136.039H23.5801V146.781Z",
    fill: "#525B6C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0648 115.199L20.9014 140.765H27.2282L24.0648 115.199Z",
    fill: "#C6D2CF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0488 131.492L26.5596 135.36L26.3862 133.958L22.189 130.36L22.0488 131.492Z",
    fill: "#B3C1BE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7412 125.889L25.5034 126.833L25.3736 125.783L22.8606 124.924L22.7412 125.889Z",
    fill: "#B3C1BE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.438 144.961H229.076V137.89H228.438V144.961Z",
    fill: "#525B6C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.757 124.173L226.676 141H230.84L228.757 124.173Z",
    fill: "#C6D2CF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.431 134.897L230.4 137.443L230.286 136.52L227.523 134.151L227.431 134.897Z",
    fill: "#B3C1BE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.888 131.208L229.705 131.83L229.62 131.139L227.966 130.574L227.888 131.208Z",
    fill: "#B3C1BE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.116 147.268C218.168 146.96 218.195 146.645 218.195 146.324C218.195 142.747 214.842 139.847 210.707 139.847C206.571 139.847 203.219 142.747 203.219 146.324C203.219 146.645 203.246 146.96 203.298 147.268H218.116Z",
    fill: "#C6D2CF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.592 145.677C226.644 145.242 226.671 144.798 226.671 144.346C226.671 139.3 223.319 135.211 219.183 135.211C215.047 135.211 211.694 139.3 211.694 144.346C211.694 144.798 211.721 145.242 211.774 145.677H226.592Z",
    fill: "#B3C1BE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.851 151.274C223.798 150.966 223.771 150.651 223.771 150.33C223.771 146.753 227.124 143.853 231.26 143.853C235.395 143.853 238.748 146.753 238.748 150.33C238.748 150.651 238.721 150.966 238.669 151.274H223.851Z",
    fill: "#B3C1BE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.866 151.274C211.8 150.839 211.766 150.395 211.766 149.943C211.766 144.898 216.015 140.808 221.258 140.808C226.501 140.808 230.751 144.898 230.751 149.943C230.751 150.395 230.717 150.839 230.65 151.274H211.866Z",
    fill: "#C6D2CF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.154 140.808C216.533 140.808 214.192 142.105 212.647 144.14C211.861 143.954 211.025 143.853 210.159 143.853C205.507 143.853 201.735 146.753 201.735 150.33C201.735 150.651 201.766 150.966 201.825 151.274H227.488C227.546 150.839 227.577 150.395 227.577 149.943C227.577 144.898 223.805 140.808 219.154 140.808Z",
    fill: "#B3C1BE"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7677 147.268C39.7156 146.96 39.6885 146.645 39.6885 146.324C39.6885 142.747 43.0411 139.847 47.1767 139.847C51.3123 139.847 54.6649 142.747 54.6649 146.324C54.6649 146.645 54.6378 146.96 54.5858 147.268H39.7677Z",
    fill: "#C6D2CF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2921 145.677C31.24 145.242 31.2129 144.798 31.2129 144.346C31.2129 139.3 34.5655 135.211 38.7012 135.211C42.8367 135.211 46.1893 139.3 46.1893 144.346C46.1893 144.798 46.1622 145.242 46.1103 145.677H31.2921Z",
    fill: "#B3C1BE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.035 151.274C34.087 150.966 34.1141 150.651 34.1141 150.33C34.1141 146.753 30.7615 143.853 26.6259 143.853C22.4903 143.853 19.1377 146.753 19.1377 150.33C19.1377 150.651 19.1648 150.966 19.2169 151.274H34.035Z",
    fill: "#B3C1BE"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.019 151.274C46.085 150.839 46.1193 150.395 46.1193 149.943C46.1193 144.898 41.8693 140.808 36.6266 140.808C31.3838 140.808 27.1338 144.898 27.1338 149.943C27.1338 150.395 27.1681 150.839 27.2341 151.274H46.019Z",
    fill: "#C6D2CF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7298 140.808C41.3501 140.808 43.6909 142.105 45.2358 144.14C46.0224 143.954 46.8584 143.853 47.7247 143.853C52.3768 143.853 56.148 146.753 56.148 150.33C56.148 150.651 56.1176 150.966 56.059 151.274H30.3956C30.337 150.839 30.3066 150.395 30.3066 149.943C30.3066 144.898 34.0778 140.808 38.7298 140.808Z",
    fill: "#B3C1BE"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.096 51.6626H161.679V47.6738H161.096V51.6626Z",
    fill: "#A18985"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.466 51.6626H157.05V47.6738H156.466V51.6626Z",
    fill: "#A18985"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.835 51.6626H152.419V47.6738H151.835V51.6626Z",
    fill: "#A18985"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.205 51.6626H147.789V47.6738H147.205V51.6626Z",
    fill: "#A18985"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.697 149.526H167.087V82.7861H161.697V149.526Z",
    fill: "#F6F4F1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.573 51.6626H143.157V47.6738H142.573V51.6626Z",
    fill: "#A18985"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.943 51.6626H138.527V47.6738H137.943V51.6626Z",
    fill: "#A18985"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.312 51.6626H133.896V47.6738H133.312V51.6626Z",
    fill: "#A18985"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.681 51.6626H129.264V47.6738H128.681V51.6626Z",
    fill: "#A18985"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.266 51.11H124.555V47.1143H101.266V51.11Z",
    fill: "#F6F4F1"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.514 77.956H199.385V56.0659H161.514V77.956Z",
    fill: "#F6F4F1"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.978 77.2257H164.307V67.2324H161.514V67.229H161.68V62.7581H161.709V61.1381H161.68V57.1211H165.978V77.2257Z",
    fill: "#ECE9E6"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.222 57.1209H201.117V55.0112H143.222V57.1209Z",
    fill: "#9FC0CB"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.331 71.6937H197.974V60.1382H189.331V71.6937Z",
    fill: "#A8B9D1"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.521 71.6937H187.164V60.1382H178.521V71.6937Z",
    fill: "#A8B9D1"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.934 71.6937H176.577V60.1382H167.934V71.6937Z",
    fill: "#A8B9D1"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6934 77.956H96.5647V56.0659H58.6934V77.956Z",
    fill: "#F6F4F1"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.9383 77.2257H92.1016V57.1211H96.5649V67.2324H93.9383V77.2257Z",
    fill: "#ECE9E6"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.428 151.274H209.293V78.2803H161.428V151.274Z",
    fill: "#F6F4F1"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.135 79.3353H211.131V77.2256H143.135V79.3353Z",
    fill: "#9FC0CB"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.497 94.33H205.896V82.7744H187.497V94.33Z",
    fill: "#A8B9D1"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.497 107.737H205.896V96.1807H187.497V107.737Z",
    fill: "#A8B9D1"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.497 121.143H205.896V109.588H187.497V121.143Z",
    fill: "#A8B9D1"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.497 134.55H205.896V122.994H187.497V134.55Z",
    fill: "#A8B9D1"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.497 147.957H205.896V136.401H187.497V147.957Z",
    fill: "#A8B9D1"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.097 94.33H185.496V82.7744H167.097V94.33Z",
    fill: "#A8B9D1"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.097 107.737H185.496V96.1807H167.097V107.737Z",
    fill: "#A8B9D1"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.097 121.143H185.496V109.588H167.097V121.143Z",
    fill: "#A8B9D1"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.097 134.55H185.496V122.994H167.097V134.55Z",
    fill: "#A8B9D1"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.097 147.957H185.496V136.401H167.097V147.957Z",
    fill: "#A8B9D1"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6992 151.274H96.5646V78.2803H48.6992V151.274Z",
    fill: "#F6F4F1"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1318 151.274H96.5642V149.533H48.1318V151.274Z",
    fill: "#ADA19F"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.279 151.274H209.712V149.533H161.279V151.274Z",
    fill: "#ADA19F"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5649 149.533H92.1016V79.335H93.9383V82.3904H96.5649V149.533Z",
    fill: "#ECE9E6"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.1016 150.882H96.5649V149.533H92.1016V150.882Z",
    fill: "#AF9893"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8613 79.3348H114.857V77.2251H46.8613V79.3348Z",
    fill: "#9FC0CB"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9609 57.1209H114.858V55.0112H56.9609V57.1209Z",
    fill: "#9FC0CB"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5645 67.2286H161.68V52.0703H96.5645V67.2286Z",
    fill: "#F6F4F1"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5645 151.274H161.68V79.5591H96.5645V151.274Z",
    fill: "#F6F4F1"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.429 121.631H157.775V85.6152H100.429V121.631Z",
    fill: "#A8B9D1"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0957 94.33H70.4951V82.7744H52.0957V94.33Z",
    fill: "#A8B9D1"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0957 107.737H70.4951V96.1807H52.0957V107.737Z",
    fill: "#A8B9D1"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0957 121.143H70.4951V109.588H52.0957V121.143Z",
    fill: "#A8B9D1"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0957 134.55H70.4951V122.994H52.0957V134.55Z",
    fill: "#A8B9D1"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0957 147.957H70.4951V136.401H52.0957V147.957Z",
    fill: "#A8B9D1"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4961 94.33H90.8954V82.7744H72.4961V94.33Z",
    fill: "#A8B9D1"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1035 71.6937H68.7471V60.1382H60.1035V71.6937Z",
    fill: "#A8B9D1"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9131 71.6937H79.5566V60.1382H70.9131V71.6937Z",
    fill: "#A8B9D1"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.502 71.6937H90.1458V60.1382H81.502V71.6937Z",
    fill: "#A8B9D1"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4961 107.737H90.8954V96.1807H72.4961V107.737Z",
    fill: "#A8B9D1"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4961 121.143H90.8954V109.588H72.4961V121.143Z",
    fill: "#A8B9D1"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4961 134.55H90.8954V122.994H72.4961V134.55Z",
    fill: "#A8B9D1"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4961 147.957H90.8954V136.401H72.4961V147.957Z",
    fill: "#A8B9D1"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.232 151.443H138.915V133.289H120.232V151.443Z",
    fill: "#A18985"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8652 71.8774H68.9852V71.2773H59.8652V71.8774Z",
    fill: "#9FC0CB"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6758 71.8774H79.7963V71.2773H70.6758V71.8774Z",
    fill: "#9FC0CB"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.2637 71.8774H90.3832V71.2773H81.2637V71.8774Z",
    fill: "#9FC0CB"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.583 71.8774H176.703V71.2773H167.583V71.8774Z",
    fill: "#9FC0CB"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.395 71.8774H187.514V71.2773H178.395V71.8774Z",
    fill: "#9FC0CB"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.981 71.8774H198.102V71.2773H188.981V71.8774Z",
    fill: "#9FC0CB"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.095 147.357H50.3438L52.095 138.109V147.357ZM62.987 136.401H52.4183L52.7688 134.55H63.3376L62.987 136.401ZM65.5258 122.994H54.957L55.3076 121.143H65.8762L65.5258 122.994ZM68.0644 109.588H57.4958L57.8463 107.737H68.415L68.0644 109.588ZM70.4944 96.7553V96.1806H60.0344L60.385 94.3295H70.4944V82.7739H72.4962V86.1846L70.4944 96.7553Z",
    fill: "#FAFAF9"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4941 94.33H60.3848L62.5729 82.7744H70.4941V94.33Z",
    fill: "#D3DCE9"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4153 107.737H57.8467L60.0348 96.1807H70.4947V96.7554L68.4153 107.737Z",
    fill: "#D3DCE9"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8763 121.143H55.3076L57.4958 109.588H68.0645L65.8763 121.143Z",
    fill: "#D3DCE9"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3383 134.55H52.7695L54.9577 122.994H65.5265L63.3383 134.55Z",
    fill: "#D3DCE9"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.9133 147.357H52.0957V138.109L52.4191 136.401H62.9878L60.9133 147.357Z",
    fill: "#D3DCE9"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4961 86.1851V82.7744H73.142L72.4961 86.1851Z",
    fill: "#D3DCE9"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6992 148.483H52.0955V82.7744H48.6992V148.483Z",
    fill: "#F6F4F1"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4969 147.356H70.4951V137.44L72.4969 126.869V134.55H76.927L76.5757 136.401H72.4969V147.356Z",
    fill: "#FAFAF9"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.495 147.357H68.6172L70.495 137.44V147.357Z",
    fill: "#D3DCE9"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.1143 122.994H73.2295L73.5808 121.143H79.4647L79.1143 122.994ZM81.6527 109.588H75.7688L76.1192 107.737H82.0031L81.6527 109.588ZM84.192 96.1807H78.3072L78.6576 94.3296H84.5424L84.192 96.1807Z",
    fill: "#FAFAF9"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.543 94.3295H78.6582L80.8471 82.7739H86.731L84.543 94.3295Z",
    fill: "#D3DCE9"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.004 107.737H76.1201L78.3081 96.1807H84.1929L82.004 107.737Z",
    fill: "#D3DCE9"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.4649 121.143H73.5811L75.769 109.588H81.6529L79.4649 121.143Z",
    fill: "#D3DCE9"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.9261 134.55H72.4961V126.869L73.2293 122.994H79.1141L76.9261 134.55Z",
    fill: "#D3DCE9"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.5003 147.357H72.4961V136.401H76.5748L74.5003 147.357Z",
    fill: "#D3DCE9"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2686 94.3294H91.1223V93.7295H72.2686V94.3294Z",
    fill: "#9FC0CB"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8682 107.737H70.7221V107.137H51.8682V107.737Z",
    fill: "#9FC0CB"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2686 107.737H91.1223V107.137H72.2686V107.737Z",
    fill: "#9FC0CB"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8682 121.143H70.7221V120.543H51.8682V121.143Z",
    fill: "#9FC0CB"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2686 121.143H91.1223V120.543H72.2686V121.143Z",
    fill: "#9FC0CB"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8682 134.55H70.7221V133.95H51.8682V134.55Z",
    fill: "#9FC0CB"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2686 134.55H91.1223V133.95H72.2686V134.55Z",
    fill: "#9FC0CB"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.429 122.231H158.806V121.631H100.429V122.231Z",
    fill: "#9FC0CB"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8682 147.956H70.7221V147.356H51.8682V147.956Z",
    fill: "#9FC0CB"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2686 147.956H91.1223V147.356H72.2686V147.956Z",
    fill: "#9FC0CB"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8682 94.3294H70.7221V93.7295H51.8682V94.3294Z",
    fill: "#9FC0CB"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4951 148.483H72.4969V82.6997H70.4951V148.483Z",
    fill: "#F6F4F1"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.415 136.402H91.1225V134.551H51.415V136.402Z",
    fill: "#F6F4F1"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.415 122.994H91.1225V121.143H51.415V122.994Z",
    fill: "#F6F4F1"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.415 109.588H91.1225V107.737H51.415V109.588Z",
    fill: "#F6F4F1"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.415 96.1807H91.1225V94.3296H51.415V96.1807Z",
    fill: "#F6F4F1"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.097 147.357H167.087V121.669L167.186 121.143H177.755L177.404 122.994H167.097V134.55H175.216L174.866 136.401H167.097V147.357ZM179.943 109.588H169.375L169.725 107.737H180.294L179.943 109.588ZM182.482 96.1807H171.913L172.264 94.3296H182.833L182.482 96.1807Z",
    fill: "#FAFAF9"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.833 94.3295H172.264L174.452 82.7739H185.02L182.833 94.3295Z",
    fill: "#D3DCE9"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.293 107.737H169.725L171.913 96.1807H182.481L180.293 107.737Z",
    fill: "#D3DCE9"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.754 121.143H167.186L169.374 109.588H179.942L177.754 121.143Z",
    fill: "#D3DCE9"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.216 134.55H167.097V122.994H177.404L175.216 134.55Z",
    fill: "#D3DCE9"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.791 147.357H167.097V136.401H174.866L172.791 147.357Z",
    fill: "#D3DCE9"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.497 147.357H185.495V137.463L187.497 126.893V134.55H191.931L191.581 136.401H187.497V147.357ZM194.119 122.994H188.235L188.586 121.143H194.47L194.119 122.994ZM196.658 109.588H190.774L191.124 107.737H197.009L196.658 109.588ZM199.197 96.1807H193.312L193.663 94.3296H199.547L199.197 96.1807Z",
    fill: "#FAFAF9"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.548 94.33H193.664L195.852 82.7744H201.736L199.548 94.33Z",
    fill: "#D3DCE9"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.01 107.737H191.125L193.313 96.1807H199.198L197.01 107.737Z",
    fill: "#D3DCE9"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.47 121.143H188.586L190.774 109.588H196.658L194.47 121.143Z",
    fill: "#D3DCE9"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.932 134.55H187.497V126.893L188.236 122.994H194.12L191.932 134.55Z",
    fill: "#D3DCE9"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.507 147.357H187.497V136.401H191.581L189.507 147.357Z",
    fill: "#D3DCE9"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.496 147.357H183.622L185.496 137.463V147.357Z",
    fill: "#D3DCE9"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.5 148.483H187.502V82.6997H185.5V148.483Z",
    fill: "#F6F4F1"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.421 136.402H206.128V134.551H166.421V136.402Z",
    fill: "#F6F4F1"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.421 122.994H206.128V121.143H166.421V122.994Z",
    fill: "#F6F4F1"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.421 109.588H206.128V107.737H166.421V109.588Z",
    fill: "#F6F4F1"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.421 96.1807H206.128V94.3296H166.421V96.1807Z",
    fill: "#F6F4F1"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1899 71.277H61.4658L64.6373 60.1382H67.3614L64.1899 71.277Z",
    fill: "#D3DCE9"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.4372 71.277H73.5303L76.7019 60.1382H78.6089L75.4372 71.277Z",
    fill: "#D3DCE9"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.5305 71.277H82.0127L85.1843 60.1382H86.7021L83.5305 71.277Z",
    fill: "#D3DCE9"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.695 71.277H168.971L172.142 60.1382H174.866L171.695 71.277Z",
    fill: "#D3DCE9"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.94 71.277H181.033L184.205 60.1382H186.112L182.94 71.277Z",
    fill: "#D3DCE9"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.034 71.277H189.517L192.688 60.1382H194.206L191.034 71.277Z",
    fill: "#D3DCE9"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.236 94.3294H206.09V93.7295H187.236V94.3294Z",
    fill: "#9FC0CB"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.835 107.737H185.689V107.137H166.835V107.737Z",
    fill: "#9FC0CB"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.236 107.737H206.09V107.137H187.236V107.737Z",
    fill: "#9FC0CB"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.835 121.143H185.689V120.543H166.835V121.143Z",
    fill: "#9FC0CB"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.236 121.143H206.09V120.543H187.236V121.143Z",
    fill: "#9FC0CB"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.835 134.55H185.689V133.95H166.835V134.55Z",
    fill: "#9FC0CB"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.236 134.55H206.09V133.95H187.236V134.55Z",
    fill: "#9FC0CB"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.835 147.956H185.689V147.356H166.835V147.956Z",
    fill: "#9FC0CB"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.236 147.956H206.09V147.356H187.236V147.956Z",
    fill: "#9FC0CB"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.835 94.3294H185.689V93.7295H166.835V94.3294Z",
    fill: "#9FC0CB"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5645 57.1207H161.68V52.0703H96.5645V57.1207Z",
    fill: "#ECE9E6"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.125 53.2191H163.12V51.1094H95.125V53.2191Z",
    fill: "#9FC0CB"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.683 47.1141H125.14V45.0044H100.683V47.1141Z",
    fill: "#9FC0CB"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.1318 133.288H159.111V128.067H99.1318V133.288Z",
    fill: "#9FC0CB"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.499 151.442H129.649V133.288H129.499V151.442Z",
    fill: "#ADA19F"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.4 151.274H157.776V133.288H154.4V151.274Z",
    fill: "#ADA19F"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.429 151.274H103.804V133.288H100.429V151.274Z",
    fill: "#ADA19F"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.603 147.357H128.292V134.25H121.603V147.357Z",
    fill: "#A8B9D1"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.855 147.357H137.544V134.25H130.855V147.357Z",
    fill: "#A8B9D1"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.12 147.357H122.201L124.506 134.25H127.425L125.12 147.357Z",
    fill: "#C4C8CF"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.505 147.357H131.587L133.893 134.25H136.811L134.505 147.357Z",
    fill: "#C4C8CF"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.142 121.631H104.154L113.173 85.6152H121.161L112.142 121.631Z",
    fill: "#D3DCE9"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.465 121.631H132.281L141.3 85.6152H156.483L147.465 121.631Z",
    fill: "#D3DCE9"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.367 123.47H114.858V85.2075H114.367V123.47Z",
    fill: "#F6F4F1"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.497 123.47H143.988V85.2075H143.497V123.47Z",
    fill: "#F6F4F1"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.733 123.47H129.224V85.2075H128.733V123.47Z",
    fill: "#F6F4F1"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.7334 104.601H159.316V104.076H99.7334V104.601Z",
    fill: "#F6F4F1"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.229 148.993H167.086V117.354H162.229V148.993Z",
    fill: "#F6F4F1"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.556 48.2575H161.68V47.6738H124.556V48.2575Z",
    fill: "#A18985"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9081 137.59C44.0096 135.248 43.1294 132.904 42.4905 130.466C40.5247 122.965 40.9993 117.498 41.0726 114.869C41.0823 114.522 40.5263 114.427 40.4777 114.785C40.3106 116.019 40.2735 117.272 40.2653 118.517C40.2515 120.621 40.379 122.726 40.6482 124.827C39.2062 125.204 37.842 124.64 36.7261 123.627C34.8024 121.883 34.1157 119.557 33.8133 116.98C33.7823 116.717 33.7728 116.467 33.5589 116.315C33.5113 116.18 33.3144 116.138 33.2656 116.34C32.9606 116.655 33.1084 117.285 33.1553 117.69C33.7901 123.178 37.1187 125.838 39.7986 125.815C40.0926 125.813 40.4499 125.797 40.7693 125.709C40.9625 127.022 41.2109 128.325 41.5147 129.615C42.0937 132.072 42.906 134.444 43.7997 136.794C46.8557 144.828 47.8308 148.933 48.6991 151.259C48.8303 151.725 49.5203 151.53 49.3996 151.057C49.3565 150.889 46.9723 142.973 44.9081 137.59Z",
    fill: "#1B2528"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1519 116.468C57.123 116.295 57.0222 116.181 56.9839 116.018C56.9333 115.805 56.5856 115.783 56.5491 116.018C56.5283 116.153 56.4539 116.236 56.425 116.373C56.3318 116.817 56.5571 119.317 55.9689 123.143C55.8126 124.16 55.64 125.171 55.3021 126.141C54.7559 127.711 53.7607 129.401 52.5231 130.471C52.4838 128.229 52.35 125.991 52.0819 123.765C51.9214 122.432 51.7189 121.107 51.4729 119.788C51.3531 119.147 51.2235 118.506 51.0843 117.87C50.9381 117.2 50.8003 116.558 50.4807 115.952C50.3826 115.766 50.1035 115.853 50.103 116.059C50.1018 116.653 50.2203 117.2 50.3439 117.778C50.467 118.352 50.5823 118.928 50.6895 119.506C51.4847 123.79 51.7838 127.595 51.7805 131.885C50.4695 130.232 49.3231 128.252 48.4738 126.308C47.4529 123.971 46.7653 121.456 46.479 118.904C46.399 118.189 46.3503 117.471 46.3351 116.754C46.3272 116.382 46.3196 116.009 46.3121 115.637C46.3083 115.446 46.2351 114.868 45.9133 115.038C45.6173 115.193 45.6454 115.54 45.6206 115.844C45.5936 116.174 45.5912 116.504 45.5954 116.836C45.6033 117.471 45.6372 118.107 45.696 118.739C46.1215 123.322 47.8471 127.852 50.4709 131.564C50.8709 132.13 51.2839 132.737 51.7696 133.231C51.6578 140.567 50.5705 149.833 50.5515 150.573C50.5474 150.736 50.5841 150.904 50.6083 151.065C50.6579 151.398 51.0943 151.321 51.1834 151.065C51.3521 150.582 51.3348 150.394 51.5862 147.718C52.0346 142.945 52.5369 132.014 52.535 131.57C54.0928 130.448 55.1959 128.723 55.9167 126.921C56.2991 125.964 56.5237 124.98 56.6921 123.962C57.2646 120.497 57.2468 117.035 57.1519 116.468Z",
    fill: "#1B2528"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4439 110.481C46.503 109.953 46.5338 109.412 46.5338 108.862C46.5338 102.728 42.73 97.7544 38.0379 97.7544C33.3457 97.7544 29.542 102.728 29.542 108.862C29.542 109.412 29.5728 109.953 29.6318 110.481H46.4439Z",
    fill: "#9FC0CB"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0582 107.751C56.1173 107.006 56.148 106.243 56.148 105.468C56.148 96.8167 52.3443 89.8032 47.6521 89.8032C42.9601 89.8032 39.1562 96.8167 39.1562 105.468C39.1562 106.243 39.1871 107.006 39.2462 107.751H56.0582Z",
    fill: "#C6D2CF"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3512 117.35C39.2763 116.605 39.2373 115.842 39.2373 115.066C39.2373 106.415 44.0593 99.4019 50.0075 99.4019C55.9558 99.4019 60.7776 106.415 60.7776 115.066C60.7776 115.842 60.7387 116.605 60.6639 117.35H39.3512Z",
    fill: "#9FC0CB"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6204 99.4019C44.6476 99.4019 41.9918 101.627 40.2391 105.116C39.3465 104.796 38.3981 104.624 37.4151 104.624C32.1371 104.624 27.8584 109.597 27.8584 115.731C27.8584 116.281 27.893 116.822 27.9594 117.35H57.0762C57.1426 116.605 57.1772 115.842 57.1772 115.066C57.1772 106.415 52.8985 99.4019 47.6204 99.4019Z",
    fill: "#C6D2CF"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.011 117.068C226.979 116.853 226.658 116.685 226.521 116.876C226.384 117.067 226.375 116.938 226.268 117.35C225.961 118.533 225.439 119.677 224.793 120.678C223.557 122.595 222.224 123.562 220.695 124.519C221.196 123.016 221.462 121.41 221.332 119.79C221.284 119.2 221.201 118.587 220.882 118.046C220.793 117.895 220.523 117.925 220.515 118.095C220.474 118.93 220.75 119.56 220.65 121.056C220.412 124.625 218.265 128.411 216.077 131.062C216.034 126.574 215.673 121.474 214.29 116.947C214.063 116.204 213.758 115.498 213.466 114.773C213.398 114.602 213.161 114.676 213.21 114.845C213.281 115.086 214.051 118.201 214.101 118.416C214.898 121.864 215.263 125.683 215.36 129.165C213.124 126.576 211.475 123.549 210.502 120.386C210.214 119.452 210.054 118.487 209.696 117.57C209.647 117.443 209.433 117.43 209.423 117.57C209.325 118.944 210.125 121.375 210.655 122.696C211.729 125.373 213.228 127.773 215.146 129.917C215.221 129.999 214.914 150.946 215.018 151.212C215.195 151.659 216.021 151.973 216.05 151.179C216.063 150.856 216.089 138.12 216.083 132.22C216.323 132.08 216.46 131.831 217.036 131.097C218.369 129.398 219.636 127.284 220.416 125.29C221.019 125.257 225.157 123.15 226.774 118.354C226.82 118.216 227.027 117.567 227.051 117.422C227.07 117.298 227.029 117.19 227.011 117.068Z",
    fill: "#1B2528"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.654 110.222C212.704 109.568 212.73 108.901 212.73 108.222C212.73 100.645 209.514 94.5029 205.548 94.5029C201.581 94.5029 198.365 100.645 198.365 108.222C198.365 108.901 198.391 109.568 198.441 110.222H212.654Z",
    fill: "#9FC0CB"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.783 106.85C220.833 105.929 220.859 104.987 220.859 104.03C220.859 93.3445 217.643 84.6826 213.676 84.6826C209.71 84.6826 206.494 93.3445 206.494 104.03C206.494 104.987 206.52 105.929 206.57 106.85H220.783Z",
    fill: "#C6D2CF"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.153 118.705C218.103 118.052 218.077 117.384 218.077 116.705C218.077 109.129 221.293 102.986 225.259 102.986C229.226 102.986 232.442 109.129 232.442 116.705C232.442 117.384 232.416 118.052 232.366 118.705H218.153Z",
    fill: "#C6D2CF"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.658 118.705C206.595 117.784 206.562 116.842 206.562 115.885C206.562 105.199 210.638 96.5376 215.667 96.5376C220.696 96.5376 224.772 105.199 224.772 115.885C224.772 116.842 224.739 117.784 224.676 118.705H206.658Z",
    fill: "#9FC0CB"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.648 96.5376C211.135 96.5376 208.89 99.2859 207.408 103.595C206.654 103.2 205.852 102.986 205.02 102.986C200.559 102.986 196.941 109.129 196.941 116.705C196.941 117.384 196.971 118.052 197.027 118.705H221.643C221.698 117.784 221.727 116.842 221.727 115.885C221.727 105.199 218.111 96.5376 213.648 96.5376Z",
    fill: "#C6D2CF"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5869 151.667H240.992V150.881H15.5869V151.667Z",
    fill: "#9FC0CB"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.158 149.533H161.693V82.3904H164.307V79.335H166.158V117.353H162.228V147.321L162.222 147.357H162.228V148.993H166.158V149.533Z",
    fill: "#ECE9E6"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.307 79.3353H166.158V79.3262H164.307V79.3353Z",
    fill: "#2C373A"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.693 150.882H166.158V149.533H161.693V150.882Z",
    fill: "#AF9893"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.229 147.356H162.223L162.229 147.321V147.356Z",
    fill: "#F1EFEC"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.229 148.993H166.158V117.354H162.229V148.993Z",
    fill: "#ECE9E6"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.693 150.889H166.158V150.881H161.693V150.889Z",
    fill: "#2C373A"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.9375 82.3908H164.306V67.2324H93.9375V82.3908Z",
    fill: "#A18985"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.9375 82.3904H164.306V75.9844H93.9375V82.3904Z",
    fill: "#977672"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.689 60.4618H104.917V58.8418H100.689V60.4618Z",
    fill: "#E8E2D9"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.3555 62.9315H101.583V61.3115H97.3555V62.9315Z",
    fill: "#E8E2D9"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.9922 65.3625H104.319V63.9917H99.9922V65.3625Z",
    fill: "#E8E2D9"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.805 62.8195H107.008V61.4487H102.805V62.8195Z",
    fill: "#E8E2D9"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.353 65.3534H132.771V64.1289H129.353V65.3534Z",
    fill: "#E8E2D9"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.615 63.3567H135.034V62.1323H131.615V63.3567Z",
    fill: "#E8E2D9"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.786 138.813H115.205V137.589H111.786V138.813Z",
    fill: "#E8E2D9"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.05 136.818H117.467V135.593H114.05V136.818Z",
    fill: "#E8E2D9"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.217 138.215H151.635V136.99H148.217V138.215Z",
    fill: "#E8E2D9"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.914 140.443H153.333V139.219H149.914V140.443Z",
    fill: "#E8E2D9"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.8 61.0277H152.027V59.4077H147.8V61.0277Z",
    fill: "#E8E2D9"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.299 65.3529H161.675V63.7329H160.299V65.3529Z",
    fill: "#E8E2D9"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.68 62.7577H161.709V61.1377H161.68V62.7577Z",
    fill: "#DBD8D4"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.769 62.7577H161.68V61.1377H158.769V62.7577Z",
    fill: "#E8E2D9"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.896 63.157H154.124V61.5371H149.896V63.157Z",
    fill: "#E8E2D9"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.174 74.7017C135.174 78.1398 132.387 80.9268 128.949 80.9268C125.511 80.9268 122.724 78.1398 122.724 74.7017C122.724 71.2636 125.511 68.4766 128.949 68.4766C132.387 68.4766 135.174 71.2636 135.174 74.7017Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.285 74.7016C134.285 77.6486 131.896 80.0374 128.949 80.0374C126.002 80.0374 123.613 77.6486 123.613 74.7016C123.613 71.7545 126.002 69.3657 128.949 69.3657C131.896 69.3657 134.285 71.7545 134.285 74.7016Z",
    fill: "#A18985"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.521 71.1554L128.45 71.1445L128.419 74.1681L125.392 74.1754L125.394 75.2447L128.408 75.238L128.377 78.2481L129.447 78.259L129.479 75.2354L132.506 75.2281L132.503 74.1588L129.49 74.166L129.521 71.1554Z",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.562 63.6961H122.791V62.0762H118.562V63.6961Z",
    fill: "#E8E2D9"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.034 61.2674H120.262V59.6475H116.034V61.2674Z",
    fill: "#E8E2D9"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.399 65.3625H152.726V63.9917H148.399V65.3625Z",
    fill: "#E8E2D9"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.279 144.335H145.507V142.716H141.279V144.335Z",
    fill: "#E8E2D9"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.375 146.465H147.602V144.846H143.375V146.465Z",
    fill: "#E8E2D9"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.878 148.67H146.204V147.3H141.878V148.67Z",
    fill: "#E8E2D9"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.24 144.669H113.468V143.048H109.24V144.669Z",
    fill: "#E8E2D9"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.144 146.797H111.371V145.178H107.144V146.797Z",
    fill: "#E8E2D9"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.542 149.003H112.869V147.632H108.542V149.003Z",
    fill: "#E8E2D9"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.91 63.1852H149.113V61.8145H144.91V63.1852Z",
    fill: "#E8E2D9"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.373 149.596H169.649V145.488H169.373V149.596Z",
    fill: "#384F54"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.976 149.596H183.251V145.488H182.976V149.596Z",
    fill: "#384F54"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.989 144.921H168.636C168.519 144.921 168.426 145.015 168.426 145.131V145.528C168.426 145.644 168.519 145.738 168.636 145.738H183.989C184.105 145.738 184.198 145.644 184.198 145.528V145.131C184.198 145.015 184.105 144.921 183.989 144.921Z",
    fill: "#C7BEAF"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.989 146.081H168.636C168.519 146.081 168.426 146.175 168.426 146.29V146.688C168.426 146.803 168.519 146.897 168.636 146.897H183.989C184.105 146.897 184.198 146.803 184.198 146.688V146.29C184.198 146.175 184.105 146.081 183.989 146.081Z",
    fill: "#C7BEAF"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.989 147.241H168.636C168.519 147.241 168.426 147.334 168.426 147.451V147.848C168.426 147.964 168.519 148.058 168.636 148.058H183.989C184.105 148.058 184.198 147.964 184.198 147.848V147.451C184.198 147.334 184.105 147.241 183.989 147.241Z",
    fill: "#C7BEAF"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.275 149.911H168.35V149.793C168.35 149.51 168.579 149.281 168.863 149.281H183.762C184.046 149.281 184.275 149.51 184.275 149.793V149.911Z",
    fill: "#C7BEAF"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.299 149.828H168.294C168.23 149.828 168.178 149.88 168.178 149.944V149.997C168.178 150.062 168.23 150.114 168.294 150.114H184.299C184.363 150.114 184.415 150.062 184.415 149.997V149.944C184.415 149.88 184.363 149.828 184.299 149.828Z",
    fill: "#384F54"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.831 154.167H169.138V150.114H168.831V154.167Z",
    fill: "#384F54"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.617 154.167H183.924V150.114H183.617V154.167Z",
    fill: "#384F54"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.02 149.596H190.295V145.488H190.02V149.596Z",
    fill: "#384F54"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.621 149.596H203.897V145.488H203.621V149.596Z",
    fill: "#384F54"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.635 144.921H189.281C189.166 144.921 189.072 145.015 189.072 145.131V145.528C189.072 145.644 189.166 145.738 189.281 145.738H204.635C204.75 145.738 204.844 145.644 204.844 145.528V145.131C204.844 145.015 204.75 144.921 204.635 144.921Z",
    fill: "#C7BEAF"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.635 146.081H189.281C189.166 146.081 189.072 146.175 189.072 146.29V146.688C189.072 146.803 189.166 146.897 189.281 146.897H204.635C204.75 146.897 204.844 146.803 204.844 146.688V146.29C204.844 146.175 204.75 146.081 204.635 146.081Z",
    fill: "#C7BEAF"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.635 147.241H189.281C189.166 147.241 189.072 147.334 189.072 147.451V147.848C189.072 147.964 189.166 148.058 189.281 148.058H204.635C204.75 148.058 204.844 147.964 204.844 147.848V147.451C204.844 147.334 204.75 147.241 204.635 147.241Z",
    fill: "#C7BEAF"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.921 149.911H188.995V149.793C188.995 149.51 189.225 149.281 189.509 149.281H204.408C204.691 149.281 204.921 149.51 204.921 149.793V149.911Z",
    fill: "#C7BEAF"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.945 149.828H188.94C188.875 149.828 188.823 149.88 188.823 149.944V149.997C188.823 150.062 188.875 150.114 188.94 150.114H204.945C205.008 150.114 205.061 150.062 205.061 149.997V149.944C205.061 149.88 205.008 149.828 204.945 149.828Z",
    fill: "#384F54"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.479 154.167H189.786V150.114H189.479V154.167Z",
    fill: "#384F54"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.263 154.167H204.57V150.114H204.263V154.167Z",
    fill: "#384F54"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.4238 149.596H75.6995V145.488H75.4238V149.596Z",
    fill: "#384F54"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.0264 149.596H89.302V145.488H89.0264V149.596Z",
    fill: "#384F54"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.0393 144.921H74.6855C74.5702 144.921 74.4766 145.015 74.4766 145.131V145.528C74.4766 145.644 74.5702 145.738 74.6855 145.738H90.0393C90.1546 145.738 90.2483 145.644 90.2483 145.528V145.131C90.2483 145.015 90.1546 144.921 90.0393 144.921Z",
    fill: "#C7BEAF"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.0393 146.081H74.6855C74.5702 146.081 74.4766 146.175 74.4766 146.29V146.688C74.4766 146.803 74.5702 146.897 74.6855 146.897H90.0393C90.1546 146.897 90.2483 146.803 90.2483 146.688V146.29C90.2483 146.175 90.1546 146.081 90.0393 146.081Z",
    fill: "#C7BEAF"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.0393 147.241H74.6855C74.5702 147.241 74.4766 147.334 74.4766 147.451V147.848C74.4766 147.964 74.5702 148.058 74.6855 148.058H90.0393C90.1546 148.058 90.2483 147.964 90.2483 147.848V147.451C90.2483 147.334 90.1546 147.241 90.0393 147.241Z",
    fill: "#C7BEAF"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.3262 149.911H74.4004V149.793C74.4004 149.51 74.6301 149.281 74.9129 149.281H89.8127C90.0965 149.281 90.3262 149.51 90.3262 149.793V149.911Z",
    fill: "#C7BEAF"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.3498 149.828H74.3447C74.2808 149.828 74.2285 149.88 74.2285 149.944V149.997C74.2285 150.062 74.2808 150.114 74.3447 150.114H90.3498C90.4137 150.114 90.466 150.062 90.466 149.997V149.944C90.466 149.88 90.4137 149.828 90.3498 149.828Z",
    fill: "#384F54"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.8818 154.167H75.189V150.114H74.8818V154.167Z",
    fill: "#384F54"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.667 154.167H89.9742V150.114H89.667V154.167Z",
    fill: "#384F54"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5752 149.596H53.8508V145.488H53.5752V149.596Z",
    fill: "#384F54"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1768 149.596H67.4524V145.488H67.1768V149.596Z",
    fill: "#384F54"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1917 144.921H52.8383C52.7227 144.921 52.6289 145.015 52.6289 145.131V145.528C52.6289 145.644 52.7227 145.738 52.8383 145.738H68.1917C68.3073 145.738 68.4011 145.644 68.4011 145.528V145.131C68.4011 145.015 68.3073 144.921 68.1917 144.921Z",
    fill: "#C7BEAF"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1917 146.081H52.8383C52.7227 146.081 52.6289 146.175 52.6289 146.29V146.688C52.6289 146.803 52.7227 146.897 52.8383 146.897H68.1917C68.3073 146.897 68.4011 146.803 68.4011 146.688V146.29C68.4011 146.175 68.3073 146.081 68.1917 146.081Z",
    fill: "#C7BEAF"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1917 147.241H52.8383C52.7227 147.241 52.6289 147.334 52.6289 147.451V147.848C52.6289 147.964 52.7227 148.058 52.8383 148.058H68.1917C68.3073 148.058 68.4011 147.964 68.4011 147.848V147.451C68.4011 147.334 68.3073 147.241 68.1917 147.241Z",
    fill: "#C7BEAF"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4775 149.911H52.5518V149.793C52.5518 149.51 52.7815 149.281 53.0648 149.281H67.9645C68.2478 149.281 68.4775 149.51 68.4775 149.793V149.911Z",
    fill: "#C7BEAF"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5008 149.828H52.4962C52.4319 149.828 52.3799 149.88 52.3799 149.944V149.997C52.3799 150.062 52.4319 150.114 52.4962 150.114H68.5008C68.5651 150.114 68.6172 150.062 68.6172 149.997V149.944C68.6172 149.88 68.5651 149.828 68.5008 149.828Z",
    fill: "#384F54"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.0332 154.167H53.3405V150.114H53.0332V154.167Z",
    fill: "#384F54"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8193 154.167H68.1266V150.114H67.8193V154.167Z",
    fill: "#384F54"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2956 145.081L38.25 145.01C38.25 145.01 38.1984 144.058 38.1984 143.604C38.1984 143.053 38.0335 142.24 38.098 142.256C38.2788 142.299 38.5911 142.468 38.7362 142.674C39.2381 143.386 39.2956 145.081 39.2956 145.081Z",
    fill: "#B3C1BE"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.396 144.045C196.398 144.036 196.399 144.028 196.401 144.02C196.399 144.028 196.398 144.036 196.397 144.045C196.397 144.045 196.397 144.045 196.396 144.045ZM196.415 143.645C196.415 143.644 196.415 143.643 196.415 143.641C196.414 143.634 196.414 143.627 196.414 143.62C196.414 143.627 196.414 143.634 196.415 143.641C196.415 143.643 196.415 143.644 196.415 143.645Z",
    fill: "#8381A3"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.154 143.84C152.14 143.776 152.128 143.712 152.115 143.65C152.128 143.712 152.14 143.776 152.154 143.84Z",
    fill: "#796163"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/Hospital.d167e48d2fbcfaa07dfb4c5d324127f2.svg";
export { ForwardRef as ReactComponent };